<template>
  <base-layout
    page-title="ChangePassword"
    page-default-back-link="/"
    page-back-link="/"
    showBackButton="true"
  >
    <!--
    <template v-slot:actions-end>
      <ion-button @click="this.$router.replace('/posts');">
        <ion-icon slot="icon-only" :icon="homeOutline"></ion-icon>
      </ion-button>
    </template>
    -->
    <form ion-padding class="left-margin-15px right-margin-15px">
      <ion-row>
        <ion-col :size="getColSize()" :offset="getOffsetSize()">
          <ion-item>
            <ion-label position="floating">Old Password</ion-label>
            <ion-input type="password" v-model="oldPassword"></ion-input>
          </ion-item>
          <password-field
            :passwordSetting="newPasswordSetting"
            :verifyCallback="verifyPasswordRules"
          ></password-field>
          <ion-item>
            <ion-label position="floating">Retype Password</ion-label>
            <ion-input
              type="password"
              v-model="retypePassword"
              autocomplete="new-password"
              @ionChange="verifyPasswordRules"
            ></ion-input>
          </ion-item>
          <ion-item v-if="passwordMismatch">
            <ion-label size="small"
              ><small>New and re-typed passwords do not match</small></ion-label
            >
          </ion-item>
          <ion-item>
            <ion-label position="floating"
              >Enter Verification Code</ion-label
            >
            <ion-input v-model="totp"></ion-input>
          </ion-item>
          <ion-item>
            <ion-button
              @click="changeThePassword()"
              :disabled="submitDisabled || !newPasswordSetting.is_valid"
              shape="round"
              >Change Password<ion-spinner
                v-if="submitDisabled"
                slot="end"
                name="dots"
              ></ion-spinner
            ></ion-button>
          </ion-item>

          <hr style="border-top: 1px dotted grey" />
          <ion-item v-if="resendVerifyMsg != ''">
            <ion-label size="small" color="secondary"
              ><small>{{ resendVerifyMsg }}</small></ion-label
            >
          </ion-item>
          <ion-item>
            <ion-text size="small" color="medium">
              Misplaced or lost the code from authenticator app?
              <ul>
                <li>
                  <small
                    >Ensure that the email given at the signup time is
                    correct</small
                  >
                </li>
                <li>
                  <small
                    >Check your email filtered folders or spam folder</small
                  >
                </li>
                <li>
                  <small
                    >You will need to setup your Authenticator app with the code
                    you receive in the email. To resend the authenticator code / OTP
                    via email.
                    <ion-button
                      color="medium"
                      size="small"
                      shape="round"
                      @click="resendVerification()"
                      ><small>click here</small
                      ><ion-spinner
                        v-if="reverifyClicked"
                        slot="end"
                        name="dots"
                      ></ion-spinner></ion-button
                  ></small>
                </li>
              </ul>
            </ion-text>
          </ion-item>
        </ion-col>
      </ion-row>
    </form>
  </base-layout>
</template>

<script>
import { getColSize, getOffsetSize } from "../services/utils";

import {
  IonButton,
  IonItem,
  IonLabel,
  //IonIcon,
  IonInput,
  IonRow,
  IonCol,
  IonText,
  alertController,
  IonSpinner,
} from "@ionic/vue";

import {
  checkmarkDoneOutline,
  closeOutline,
  homeOutline,
} from "ionicons/icons";

import { changePassword, resendVerifySession } from "../services/apiCall";
import { useRouter } from "vue-router";
import { readFromDB, clearObjectStore, closeDB } from "../services/db.js";
import PasswordField from "../components/settings/PasswordField.vue";

export default {
  components: {
    IonButton,
    IonItem,
    IonLabel,
    //IonIcon,
    IonInput,
    IonRow,
    IonCol,
    IonText,
    IonSpinner,
    PasswordField,
  },
  ionViewDidEnter() {
    console.log("PasswordChange page did enter");
  },
  ionViewDidLeave() {
    console.log("PasswordChange page did leave");
  },
  ionViewWillEnter() {
    console.log("PasswordChange page will enter");

    const callbackObject = this;
    readFromDB(this.$store)().then(async () => {
      // read from DB done
      console.log("read from db, user", callbackObject.user);

      if (
        typeof callbackObject.user === "undefined" ||
        typeof callbackObject.user.user_id === "undefined"
      ) {
        await clearObjectStore();
        await closeDB();
        callbackObject.router.replace("/login");
      }
    });
  },
  ionViewWillLeave() {
    console.log("PasswordChange page will leave");
  },
  setup() {
    const router = useRouter();

    return {
      router,
      getColSize,
      getOffsetSize,
    };
  },
  data() {
    return {
      changePassword,
      checkmarkDoneOutline,
      closeOutline,
      homeOutline,
      submitDisabled: false,
      reverifyClicked: false,
      oldPassword: "",
      resendVerifyMsg: "",
      newPasswordSetting: {
        name: "New Password",
        password: "",
        is_valid: false,
      },
      retypePassword: "",
      totp: "",
      passwordRuleError: true,
      passwordRules: {
        minEightChars: false,
        minOneSpecialChar: false,
        minOneUpperCase: false,
        minOneNumeric: false,
      },
      passwordMismatch: false,
    };
  },
  computed: {
    user() {
      console.log("user", this.$store.getters.user);
      return this.$store.getters.user;
    },
  },
  methods: {
    verifyPasswordRules() {
      this.passwordMismatch =
        this.newPasswordSetting.password !== this.retypePassword;
    },
    async showError(title, msg) {
      const failedAlert = await alertController.create({
        header: title,
        message: msg,
        buttons: ["OK"],
      });
      await failedAlert.present();
    },
    changeThePassword() {
      console.log("changeThePassword");

      var checkEmptyPasswordMsg = "";
      if (this.oldPassword === "") {
        checkEmptyPasswordMsg = "Please enter your old password";
      } else if (this.newPasswordSetting.password === "") {
        checkEmptyPasswordMsg = "Please enter your new password";
      } else if (this.retypePassword === "") {
        checkEmptyPasswordMsg = "Please enter your new password";
      } else if (this.totp === "") {
        checkEmptyPasswordMsg =
          "Please enter authentication code from Authenticator app that you had setup for your NEXT account";
      }

      if (checkEmptyPasswordMsg != "") {
        this.showError(
          "Incomplete Form",
          "Incomplete Form, " + checkEmptyPasswordMsg
        );
        return;
      }

      this.submitDisabled = true;
      changePassword({
        old_password: this.oldPassword,
        new_password: this.newPasswordSetting.password,
        totp: this.totp,
      })
        .then(async (res) => {
          console.log("changePassword", res);
          if (res.data.status === 0) {
            this.submitDisabled = false;
            const successAlert = await alertController.create({
              header: "Password Changed",
              message: "New password set successfully.",
              buttons: ["OK"],
            });
            await successAlert.present();
            this.router.push("/user/profile");
          } else {
            this.submitDisabled = false;
            this.showError(
              "Password Change Error",
              "Password Change Failed. Message from Server: " +
                res.data.error.error_message
            );
          }
        })
        .catch(async (err) => {
          this.submitDisabled = false;
          console.log("changePassword - err", err);
          this.showError(
            "Password Change Failed",
            "Password Change Failed. Error is: " + err
          );
        });
    },
    resendVerification() {
      this.reverifyClicked = true;
      var options = {};

      this.resendVerifyMsg = "";

      resendVerifySession(options)
        .then((res) => {
          console.log("resendVerify", res);
          if (res.data.status === 0) {
            this.resendVerifyMsg =
              "Email with authenticator code resent, please check your email.";
            this.reverifyClicked = false;
          } else {
            this.resendVerifyMsg = "Failed to send email, try again.";
            this.reverifyClicked = false;
          }
        })
        .catch((err) => {
          this.reverifyClicked = false;
          this.resendVerifyMsg = "Failed to send email, try again.";
          console.log("resendVerify - err", err);
        });
    },
  },
};
</script>